import { Fragment, useEffect } from 'react';
import { ContractLink } from '~/components/contract-link';
import { LinkProps } from '~/components/link';
import { ContractVersion } from '~/typings/context';

export type CommaSeparatedLinksProps = {
  contracts: ContractVersion[];
  linkProps?: LinkProps;
  lastConjunction?: string;
  utilityAccountId?: number;
  showPersonalizedContractPreview: boolean;
};

export const CommaSeparatedLinks = ({
  lastConjunction = ' and ',
  contracts,
  linkProps,
  utilityAccountId,
  showPersonalizedContractPreview,
}: CommaSeparatedLinksProps) => {
  useEffect(() => {
    // To disable right click on the contracts and
    // to fire left click on right click action

    const handleContextMenu = e => {
      e.preventDefault();
      e.target.click();
      return false;
    };
    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  return (
    <>
      {contracts.map((contract, i) => (
        <Fragment key={contract.id}>
          {getCommaSeparator(i, i === contracts.length - 1, lastConjunction)}
          <ContractLink
            contract={contract}
            linkProps={linkProps}
            showPersonalizedContractPreview={showPersonalizedContractPreview}
            utilityAccountId={utilityAccountId}
          />
        </Fragment>
      ))}
    </>
  );
};

export const getCommaSeparator = (index: number, isLast: boolean, lastConjunction: string) => {
  if (index === 0) {
    return '';
  } else if (isLast) {
    return index === 1 ? lastConjunction : `,${lastConjunction}`;
  } else {
    return ', ';
  }
};
